export default __webpack_public_path__ + "static/media/Dashboard_icon_white.670b45ad.svg";